
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import '../../../node_modules/core-js/modules/es.array.concat.js';
import '../../../node_modules/core-js/modules/es.array.filter.js';
import '../../../node_modules/core-js/modules/es.array.includes.js';
import '../../../node_modules/core-js/modules/es.array.iterator.js';
import '../../../node_modules/core-js/modules/es.array.map.js';
import '../../../node_modules/core-js/modules/es.number.constructor.js';
import '../../../node_modules/core-js/modules/es.object.to-string.js';
import '../../../node_modules/core-js/modules/es.set.constructor.js';
import '../../../node_modules/core-js/modules/es.string.includes.js';
import '../../../node_modules/core-js/modules/es.string.iterator.js';
import '../../../node_modules/core-js/modules/web.dom-collections.iterator.js';
import { Actions } from './constants.js';

var reducer = function reducer(state, action) {
  switch (action.type) {
    case Actions.toggleAll:
      {
        var hasSelected = state.selected.length > 0;
        var newSelected = hasSelected ? [] : _toConsumableArray(state.rows);
        return _objectSpread2(_objectSpread2({}, state), {}, {
          selected: newSelected
        });
      }
    case Actions.toggle:
      {
        var selectedRowId = action.payload.id;
        var selectedRowsIds = state.selected.map(function (entry) {
          return entry.id;
        });
        var isRowSelected = selectedRowsIds.includes(selectedRowId);
        if (isRowSelected) {
          // remove row from selected
          var newSelectedRows = state.selected.filter(function (row) {
            return (row === null || row === void 0 ? void 0 : row.id) !== selectedRowId;
          });
          return _objectSpread2(_objectSpread2({}, state), {}, {
            selected: newSelectedRows
          });
        } else {
          // add row to selected
          return _objectSpread2(_objectSpread2({}, state), {}, {
            selected: [].concat(_toConsumableArray(state.selected), [action.payload])
          });
        }
      }
    case Actions.selectMany:
      {
        var uniqueSelected = _toConsumableArray(new Set(action.payload));
        var selectedRows = state.rows.filter(function (row) {
          return uniqueSelected.includes(Number(row.id));
        });
        return _objectSpread2(_objectSpread2({}, state), {}, {
          selected: [].concat(_toConsumableArray(state.selected), _toConsumableArray(selectedRows))
        });
      }
    case Actions.sortingChanged:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          sorting: action.payload
        });
      }
    case Actions.columnsChanged:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          columns: action.payload
        });
      }
    case Actions.rowsChanged:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          rows: action.payload
        });
      }
    case Actions.resetSelectedRows:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          selected: []
        });
      }
    case Actions.setDisabled:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          disabled: action.payload
        });
      }
    default:
      {
        return state;
      }
  }
};

export { reducer };
//# sourceMappingURL=reducer.js.map
